import App from 'app/app.js';
import template from './flag-label.html';
import './flag-label.scss';

class FlagLabel {}

App.component('ltFlagLabel', {
  template,
  bindings: {
    text: '<'
  },
  controller: FlagLabel,
  controllerAs: '$ctrl'
});
